import { faBolt, faBoxOpen, faFileCircleCheck, faFileSignature, faLightbulb } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { changeTab, newTab, setTabFromNewIndex } from "../../state/slices/tabsSlice";
import styles from "./DashboardGeracao.module.css"

const DashboardGeracao = () => {
    const dispatch = useDispatch();
    const tabs = useSelector(state => state.tabs);
    const user = useSelector(state => state.user);
    
    const onClickAbrirEquipamentos = () => {
        const listaEquipamentos = {
            Nome: "Equipamentos",
            Aba: 1
        }
        
        dispatch(newTab(listaEquipamentos));
        
        dispatch(setTabFromNewIndex(listaEquipamentos.Aba));

    }

    const onClickAbrirConsulta = () => {
        const listaConsulta = {
            Nome: "Orçamento estimado",
            Aba: 2
        }

        dispatch(newTab(listaConsulta));

        
        dispatch(setTabFromNewIndex(listaConsulta.Aba));
    }

    const onClickAbrirSolicitacaoAcesso = () => {
        const listaSolicitacaoAc = {
            Nome: "Orçamento de conexão",
            Aba: 3
        }

        dispatch(newTab(listaSolicitacaoAc));

        dispatch(setTabFromNewIndex(listaSolicitacaoAc.Aba));
    }

    const onClickAbrirSolicitacaoVistoria = () => {
        const listaSolicitacaoVistoria = {
            Nome: "Solicitação de vistoria",
            Aba: 4
        };

        dispatch(newTab(listaSolicitacaoVistoria));

        
        dispatch(setTabFromNewIndex(listaSolicitacaoVistoria.Aba));
    }
    

    return (
        <div className={styles.dashboard_main}>
            <section className={styles.dashboardSection}>
                <button className={styles.dashboardButton} onClick={onClickAbrirEquipamentos}>
                    <FontAwesomeIcon icon={faBoxOpen} size="2x" />
                    Equipamentos
                </button>
                
                <button className={styles.dashboardButton} onClick={onClickAbrirConsulta}>
                    <FontAwesomeIcon icon={faFileCircleCheck} size="2x" />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        Orçamento estimado
                    </div>
                </button>

                <button className={styles.dashboardButton} onClick={onClickAbrirSolicitacaoAcesso}>
                    <FontAwesomeIcon icon={faFileSignature} size="2x" />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        Orçamento de conexão
                    </div>
                </button>

                <button className={styles.dashboardButton} onClick={onClickAbrirSolicitacaoVistoria}>
                    <FontAwesomeIcon icon={faLightbulb} size="2x" />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        Solicitação de vistoria
                    </div>
                </button>
            </section>
            <p className={styles.merchanUseall}>Desenvolvido por <a className={styles.linkUseall} href="http://www.useall.com.br" target={"_blank"}>Useall Software</a></p>
        </div>
    )
};

export { DashboardGeracao };